import {update} from './GridUtils';

const coordinateGridSpacing = [
    20.0, // 0
    20.0, // 1
    20.0, // 2
    10.0, // 3
    5.0, // 4
    5.0, // 5
    2.0, // 6
    1.0, // 7
    0.5, // 8
    0.25, // 9
    0.2, // 10
    (1.0 / 60.0) * 3, // 11
    (1.0 / 60.0) * 1.5, // 12
    (1.0 / 60.0), // 13
    (1.0 / 120.0), // 14
    (1.0 / 200.0), // 15
    (1.0 / 320.0), // 16
    (1.0 / 440.0), // 17
    (1.0 / 540.0), // 18
];

function formatLabelDMS({deg, type}: {deg: number; type: string}) {
    let direction = '';
    if (type === 'parallel') {
        direction = (deg > 0) ? 'N' : 'S';
    } else {
        if (deg > 180) {
            deg -= 360;
        } else if (deg < -180) {
            deg += 360;
        }
        if (deg === -180) {
            deg = 180;
        }
        direction = (deg > 0) ? 'E' : 'W';
    }

    const degPositive = Math.abs(deg); //Doesn't matter if it's N, S, W, E

    const degrees = Math.floor(degPositive);
    let minutes = Math.floor((degPositive - degrees) * 60);
    let seconds = Math.round((degPositive - degrees - (minutes / 60)) * 3600);

    if (seconds === 60) {
        minutes += 1;
        seconds = 0;
    }

    if (minutes === 60) {
        deg += 1;
        minutes = 0;
    }

    const minutesFormatted = (minutes > 0) ? `${minutes}' ` : '';
    const secondsFormatted = (seconds > 0) ? `${seconds}" ` : '';

    return `${degrees}° ${minutesFormatted}${secondsFormatted}${direction}`;
}

const DMSGrid: GridGenerator = function (
    bounds: mapboxgl.LngLatBounds,
    zoom: number
): mapboxgl.Style {
    return update({
        id: 'lng|lat|dms',
        bounds,
        zoom,
        coordinateGridSpacing,
        labelFunc: formatLabelDMS
    });
};

export default DMSGrid;
